export default {
  nameResolution: {
    requiredFailed:
      '必要表面 {{name}} 未成功對應。請先檢查擷取結果，再產生網格。',
    requiredFailedCoolant:
      '名稱 {{name}} 未成功對應到切出的冷卻液。請在邊界指定中檢查後，再重新切出。',
    highlight: '反白顯示 {{name}}',
    loading: '正在載入已命名表面結果…',
    loadFailed: '無法載入已命名表面結果。',
    retry: '重試',
    title: '已命名表面',
    landed: '已套用',
    failed: '失敗',
    coverage: '佔準備後表面的 {{share}}',
    coverageUnavailable: '無表面佔比資料',
    mergedInto: '已與 {{name}} 合併',
    reason: {
      not_boundary_opening:
        '此開口不在冷卻流道邊界上。請選擇其他偵測到的開口。',
      no_cad_record: '此名稱沒有可用的 CAD 面記錄。',
      normal_disagreement:
        '擷取表面與此命名牆面不一致。變更流道尺寸無法修正此轉移。',
      no_match_in_band: '擷取無法解析此命名牆面。變更流道尺寸無法修正此轉移。',

      spatial_match_failed: '找不到相符的準備後表面。',
      ambiguous_match: '有多個表面與此面相符。',
      no_descriptors: '無法取得原始 CAD 面的資訊。',
      resolved: '未記錄結果表面。',
      merged: '此合併名稱未記錄結果表面。',
      // 保留的 patch 名稱會在網格階段重新命名 (ENG-3076)。
      renamed: '此名稱為保留字；表面已以產生的 patch 名稱套用。',
    },
  },
  // 網格圓點 / 重試記錄 / 檔案樹使用的 MeshStatus 標籤 (ENG-1744).
  // 用詞沿用既有目錄 (simopsMisc.statusBadge,
  // simopsFiles.studyTree.quality*). `recombining` 與 `meshing` 同文案 —
  // 重組是網格生成的內部步驟, 不應顯示使用者無法控制的階段名稱.
  meshStatus: {
    completed: '已完成',
    failed: '失敗',
    meshing: '建立網格中…',
    recombining: '建立網格中…',
    pending: '待處理',
    cancelled: '已取消',
  },
  failureMessage: {
    // BE 傳回的常見 pipeline 失敗訊息的本地化文案. 由
    // utils/failureMessage.ts:translateFailureMessage 以 regex 對「已
    // 清理」的英文原始訊息比對, 首匹配優先.
    stlNotWatertight:
      'STL 非閉合 — 偵測到開放邊。請在 CAD 中封蓋開口後重新匯出。',
    degenerateTriangles:
      'STL 內含退化（零面積）三角面片。請以較細的弦高/角度容差重新匯出。',
    stlUnreadable: '無法讀取 STL — 檔頭可能損毀。請從 CAD 工具重新匯出。',
    stlEmpty: 'STL 沒有任何三角面片。檔案可能寫成空的 — 請重新匯出後再試。',
    stlSingleSolid:
      'STL 沒有命名的 solid, 無法逐個 patch 標記 — 網格化仍可進行, 但邊界條件會套用至整個表面。若需逐 patch 標記, 請以「含命名 solid 的 ASCII STL」重新匯出。',
    selfIntersection:
      '幾何自交 — 表面自我穿越。請在 CAD 中修正交集（例如將重疊本體聯集）並重新上傳。',
    nonManifold:
      '非流形邊 — 三個以上的面共用同一邊, 或表面有 T 形接點。請在 CAD 中清理（通常是將重疊本體聯集或裁切）。',
    pinchPoint:
      '夾點 — 兩個表面在單一點相接卻不共面。自動修復會使實體塌陷; 請在 CAD 中將本體聯集, 使其共用一個面。',
    overlappingFaces:
      '重疊或共面 — 兩個表面佔據同一空間。請在 CAD 中聯集多餘的本體, 或移除重複面。',
    couldNotHeal:
      '自動修復無法治癒此幾何。缺陷需在 CAD 端處理 — 請嘗試「簡化（聯集本體）」, 或在 CAD 工具中修正後重新上傳。',
    timedOut:
      '診斷逾時 — 幾何過於複雜, 超出可用計算時間。請嘗試簡化模型或移除細小特徵。',
    outOfMemory:
      '幾何使分析器記憶體耗盡。請嘗試拆分組件, 或移除細小特徵/重複本體。',
    unsupportedFormat:
      '不支援此檔案格式。請嘗試以 STEP（建議）或 STL 重新匯出。',
    couldNotRead: '無法讀取此檔案。請以 CAD 工具的預設設定重新匯出。',
    zeroVolume:
      '幾何沒有實體體積 — 可能是表面本體或草圖。網格化需要封閉的固體。',
    noGeometry:
      '檔案中找不到幾何。可能為空、只含點或曲線, 或使用不支援的格式。',
    // 網格 pipeline (Diagnosis 之後) 的失敗訊息. 於 MeshResultsPanel
    // 對 meshResults.error 與 failedStageReport.message 做比對.
    meshTimedOut:
      '網格化在此階段完成前逾時。請調高「策略執行時間上限」、放寬最小尺寸, 或降低最大細化層級。',
    meshOutOfMemory:
      '網格化過程記憶體不足。請放寬最小尺寸、降低最大細化層級, 或拆分組件。',
    meshPolyBlCrash:
      '多面體網格器已崩潰 (SIGSEGV) — 多半是細網格尺寸或髒表面下的邊界層細化器所致。請關閉邊界層，或改用較粗的最大/最小尺寸重試。',
    // 「pipeline」= 網格化的多階段作業流程 (Diagnosis → Meshing →
    // Quality → Healing → Conversion). 中文避免留英文原文, 沿用
    // 一般 CFD 工作流語境的「作業流程」.
    meshPipelineFailed:
      '網格作業流程在產生結果前就中止了。請參閱下方紀錄與階段報告以確認失敗的步驟。',
    meshingFailedGeneric:
      '網格化失敗。請參閱下方紀錄與階段報告以確認失敗的步驟。',
    meshAddLayers:
      '此次執行的邊界層擠出 (snappyHexMesh addLayers) 失敗。請嘗試減少層數、降低第一層高度, 或勾選「優先確保 BL 覆蓋率」。',
    meshSnapFailed:
      'snap 階段 (snappyHexMesh snap) 在此幾何上無法收斂。請嘗試放寬特徵角、啟用「Snap Fidelity」, 或先修復 CAD。',
    meshFaceTagUnresolved:
      '必要的 inlet 或 outlet 標記未對應到欲網格化表面上的任何面，因此在網格化開始前就停止了。這是標記問題，不是 CAD 問題。請開啟「邊界指定」，確認「網格來源」(流體域 / 實體) 與你標記的面一致，然後重新標記 inlet 與 outlet。',
    meshBlockmeshFailed:
      'blockMesh 無法建立此次執行的背景網格。請檢查包圍盒係數與 BlockMesh 網格單元尺寸覆寫。',
    meshWireball:
      'snap 產生退化/非凸單元 (wireball)。請嘗試啟用「Snap Fidelity」, 或改以 Wrap 方式上傳而非 Repair。',
    meshCellBudget:
      '此次網格會超出單元數上限。請調高「Max Local Cells/Max Global Cells」, 或將網格粗化 (放寬最小尺寸、降低細化)。',
    // 各子階段的具體逾時訊息 — {{seconds}} 由 extractTimeoutSeconds
    // 由 BE 的原始英文訊息「after Ns」解析出來.
    afterSeconds: '（{{seconds}} 秒後）',
    assemblySplitIgnored: '組件分割網格化忽略了下列覆寫：{{overrides}}',
    meshSnappyTimedOut:
      'snappyHexMesh（`openfoam_snappy`）逾時{{after}} — 整個策略時間預算用盡但仍未產出最終網格。請查看上方階段時間軸, 確認預算用盡時仍在執行的內部步驟（blockMesh/snap/addLayers）。修正方式：放寬最小尺寸、降低最大細化層級, 或在「進階」中調高「策略執行時間上限」。',
    meshBlockmeshTimedOut:
      'blockMesh（`openfoam_blockmesh`）在建立背景網格時逾時{{after}}。請將背景網格粗化 — 放大 BlockMesh 網格單元尺寸或縮小包圍盒。',
    meshAddLayersTimedOut:
      'addLayers 階段（`openfoam.add_layers`）在擠出邊界層單元時逾時{{after}}。請嘗試減少邊界層層數、降低第一層高度, 或勾選「優先確保 BL 覆蓋率」。',
    meshSnapTimedOut:
      'snap 階段（`openfoam.snap`）在將網格對齊 CAD 特徵邊時逾時{{after}}。請放寬特徵角、啟用「Snap Fidelity」, 或先修復 CAD。',
    meshGmshTimedOut: 'Gmsh 逾時{{after}}。請放寬最小尺寸或降低細化層級。',
    // 網格化後的品質警告 — 成功的網格化執行中 checkMesh 標示問題時
    // 顯示的黃色警告列. 數值由 translateMeshWarning 從 BE 英文原文
    // 插值取出.
    warnHighSkewness:
      '最大歪度 = {{value}}, 偵測到 {{count}} 個高歪度面 — 這些單元附近的求解精度可能下降。可考慮調高最大細化層級, 或於標示區域修復 CAD。',
    warnHighNonOrtho:
      '最大非正交角 = {{value}}°, 偵測到 {{count}} 個高非正交面 — 求解器可能需要更多非正交修正次數。請將「非正交修正次數」調至 3~4, 或降低「最大非正交角」後重新網格化。',
    warnHighAspect:
      '最大展弦比 = {{value}}, 偵測到 {{count}} 個高度拉伸單元 — 通常是邊界層與主體網格銜接不良所致。請嘗試較低的生長比或較粗的最小尺寸。',
    warnNegativeVolume:
      '偵測到 {{count}} 個負體積單元 — 網格無法在此狀態下求解。請放寬最小尺寸、降低最大細化層級, 或於標示單元附近修復 CAD。',
    warnCheckMeshFailed:
      '有 {{count}} 個單元未通過 checkMesh。求解器仍可執行, 但這些單元附近的結果可靠度較低。可考慮收緊品質目標或重新網格化。',
    warnBlCoverage:
      '邊界層覆蓋率 {{actual}}%（目標 {{target}}%）。部分壁面沒有或僅有部分邊界層 — 請啟用「優先確保 BL 覆蓋率」, 或降低層數/第一層高度。',
    warnZeroNegativeFaceArea:
      '偵測到零或負面積的面（最小 = {{minArea}}）。checkMesh 標示出退化面 — 網格無法安全求解。請放寬最小尺寸、降低最大細化層級, 或於標示區域附近修復 CAD。',
    warnFacePyramids:
      '{{count}} 個面方向不正確（checkMesh facePyramids）。非流形或法向反轉的幾何 — 請修復該區域的 CAD, 或以較粗的最小尺寸重新網格化以避免 snappy 在該處產出退化面。',
  },
  fastenerInterfaces: {
    title: '偵測到的螺栓接觸面 ({{count}})',
    criteriaTooltip:
      '當兩個圓柱分屬不同實體、互相平行、沿軸向重疊，且螺桿位於孔內時才會列出。\n\n孔半徑也必須在螺桿半徑的 4 倍以內；沒有這個上限，外殼（例如軸管或輪轂孔）會把所有穿過它的螺栓都收為己有。\n\n間隙與偏心只作為量測值呈現，不做良否判定：鉚釘會填滿孔、肩螺栓為緊配、長槽托架則刻意保留鬆動量。',
    hint: '命名配對會為兩側面加上標籤。接觸配對請在 SimOps 中建立，也可在那裡調整。',
    loadFailed: '無法讀取此幾何的螺栓接觸面。',
    notMeasured: '此幾何未量測螺栓配合，請重新執行診斷。',
    legacyDiagnosis_one:
      '有 {{count}} 組配對缺少面識別資訊，無法套用。請重新執行診斷。',
    legacyDiagnosis_other:
      '有 {{count}} 組配對缺少面識別資訊，無法套用。請重新執行診斷。',
    bodyPair: '螺栓 Vol {{shank}} → Vol {{hole}}',
    fit: '間隙 {{clearance}} mm · 偏心 {{eccentricity}} mm',
    interference: '螺桿比孔還粗，請檢查模型。',
    selectPair: '選取螺栓 Vol {{shank}} → Vol {{hole}} 以命名',
    applySelected_one: '為選取的 {{count}} 組命名',
    applySelected_other: '為選取的 {{count}} 組命名',
    apply: '命名面',
    applied: '已命名',
    unbindable: '這些面不在目前的視圖中，切換回原視圖才能套用。',
    verdict: {
      no_head_seating: '無頭部承壓面',
      no_modelled_head: '未建模頭部',
    },
    verdictHint: {
      no_head_seating: '頭部未超出孔壁，預緊力沒有可承壓的面。',
      no_modelled_head: '找不到面向軸向的平面，無法評估頭部承壓。',
    },
  },
  bodyPartName: {
    tooltip: 'CAD 檔案中的零件名稱',
  },
  structuralBodies: {
    title: '本體指派',
    description:
      '為每個本體命名並指定類別。儲存在幾何上，因此後續每個步驟都會使用相同名稱。標籤僅供閱讀 — 求解器仍以 Volume_<索引> 稱呼每個本體。',
    runDiagnosisFirst: '尚無本體。請對此幾何執行診斷以列出其體積。',
    volumeLabel: '體積 {{index}}',
    labelFor: '體積 {{index}} 的名稱',
    hideBody: '隱藏體積 {{index}}',
    showBody: '顯示體積 {{index}}',
    roleFor: '將體積 {{index}} 設為{{role}}',
    roleMember: '構件',
    roleFastener: '緊固件',
    roleExcluded: '排除',
    roleMemberTooltip: '承載荷重的組件。會建立網格並求解。',
    roleFastenerTooltip:
      '螺栓、鉚釘或銷。會建立網格並求解，並與其連接的構件分開回報。',
    roleExcludedTooltip: '完全排除於網格之外 — 沒有元素、結果或接觸。',
    detectedBadge: '建議',
    detectedTooltip: '由緊固件偵測建議且尚未確認。請選擇類別以確認或修正。',
    save: '儲存指派',
    saving: '儲存中…',
    savedToast: '已儲存本體指派。',
    conflictToast: '其他人變更了本體指派。您的編輯已保留 — 請檢查後再次儲存。',
    saveFailedToast: '無法儲存本體指派。請重試。',
  },
  bodyClassification: {
    title: '本體分類',
    cavity: '腔體',
    body: '本體',
    cavityTooltip:
      '顯示流體通道（腔體 STL）。將游標移到某個流體體積上時，會亮起其腔體面。',
    bodyTooltip:
      '顯示壁面幾何（本體 STL）。將游標移到某個固體體積上時，會亮起其壁面。',
    description:
      '為每個 CAD 實體指定多區域 CHT 的角色。必須恰好有一個流體區域，以及至少一個固體區域。',
    meshFromBodyNote:
      '邊界指定中的「網格來源」設為「本體」，因此腔體檢視已關閉。改回「流體域」會清除此零件的表面標籤與邊界層 wall 選取；改回後，請在此選取「腔體」。',
    runDiagnosisFirst: '請先執行 Diagnosis 以偵測 CAD 實體。',
    volumesDetected_one:
      '偵測到 {{count}} 個實體。請重新執行 Diagnosis 以載入實體詳細資料。',
    volumesDetected_other:
      '偵測到 {{count}} 個實體。請重新執行 Diagnosis 以載入實體詳細資料。',
    volumeLabel: '實體 {{index}}',
    regionLabelPlaceholder: '區域標籤',
    invalidLabels: '標籤只能使用英文字母、數字和底線（不可有空格或特殊字元）。',
    duplicateLabels_one: '重複的標籤：',
    duplicateLabels_other: '重複的標籤：',
    assignOneFluid: '請恰好指定一個實體為流體。 ',
    onlyOneFluid: '只允許一個流體區域。 ',
    atLeastOneSolid: '至少需要一個固體區域。',
    validSummary: '已設定 {{fluidCount}} 個流體 + {{solidCount}} 個固體區域。',
    cavityBadge: '擷取',
    cavityBadgeTooltip:
      '這是零件內部的空間。它是從幾何中自動偵測出來的，並非 CAD 檔案中的實體，通常就是流體。',
    roleFluid: '流體',
    roleSolid: '固體',
    roleExclude: '排除',
    descriptionWrap:
      '請在網格化之前為每個零件命名。名稱會成為該零件在網格與 SimOps 中的區域名稱。',
    coolantRow: '冷卻液',
    coolantRowNote: '在邊界指定中由流道切出，因此不是您的 CAD 零件。',
    solidOnlyTooltip:
      '在 Wrap 網格中，每個 CAD 零件都是固體。冷卻液由流道切出，因此沒有零件是流體；也不能排除任何零件，因為那會改變切割結果。',
    noHighlight: '3D 檢視目前還無法標示這些零件。',
    cavityTooltipWrap: '在半透明的壁面內顯示切出的冷卻液。僅供觀看。',
    bodyTooltipWrap: '顯示零件。將游標移到卡片上時，會亮起該零件。',
    cavityLookOnlyNote:
      '腔體檢視僅供觀看：零件不會亮起，點選也不會選取任何項目。若要找出零件，請切換到「本體」。',
    waitingForPartCheck:
      '仍在檢查此上傳檔案是否有獨立零件。檢查完成後，零件會顯示在這裡。',
    partsCannotBeNamed: '此上傳檔案的零件無法命名。',
    refusals: {
      blank: '名稱不可為空白。',
      tooLong: '「{{label}}」超過 {{max}} 個字元。',
      folderName: '「{{label}}」是 OpenFOAM 自身使用的資料夾名稱。',
      interfaceInfix:
        '「{{label}}」包含 _to_，OpenFOAM 用它來命名區域之間的壁面。',
      interfaceSuffix: '「{{label}}」以 _to 結尾，相鄰壁面會被讀成錯誤的區域。',
      sameFolder:
        '「{{other}}」與「{{label}}」只有大小寫不同，macOS 與 Windows 會視為同一個資料夾。',
      sameRegion: '「{{other}}」與「{{label}}」會變成同一個區域名稱。',
      coolantName: '「{{label}}」是冷卻液的名稱。',
      solidName: '「{{label}}」是網格無法分離零件時為金屬部分所取的名稱。',
      airName: '「{{label}}」保留給受困空氣的區域（air_0、air_1 等）。',
      otherPartDefault: '「{{label}}」是另一個零件的預設名稱。',
    },
  },
  boundaryAssignment: {
    suggestedLabels: {
      fixed: '固定支承',
      load: '載荷',
      pressure: '壓力',
      symmetry: '對稱',
      contact: '接觸',
      surface: '表面',
      wall: '壁面',
      inlet: '入口',
      outlet: '出口',
      farfield: '遠場',
    },
    title: '邊界指定',
    preview: '預覽',
    faceLabelsConflictToast:
      '無法儲存表面標籤 — 已在其他工作階段中變更。請重新整理以載入最新版本。',
    descriptionFea:
      '在網格化前為 CAD 表面加上標籤，以便在 SimOps 中為每個表面設定邊界條件。',
    descriptionFlow:
      '為每個表面指定邊界角色。已偵測的開口會預先標示；其餘面預設為 wall。',
    descriptionCoolant:
      '找出冷卻液流經的開口，視需要為其命名，然後從零件中切出冷卻液。留空的開口會自動命名；名稱無法表示流向的開口，SimOps 會請您指定冷卻液的流動方向。',
    // ENG-1869 — 參見英文版註解。不指出原因，也不提供解法。
    bodySurfaceFallbackTitle: '標示將綁定到實體本體',
    bodySurfaceFallbackBody:
      '此幾何尚未擷取流體腔體，因此下方顯示的是實體本體的表面，而非腔體的表面。inlet / outlet 面需手動標示，且無法預覽已網格化的腔體。',
    hideEnclosure: '隱藏包圍盒',
    showEnclosure: '顯示包圍盒',
    enclosureFaces: '包圍盒面',
    resetAllToDefaults: '全部重設為預設值',
    reset: '重設',
    faceReadoutWithDiameter:
      '每個面的讀數。平面、圓柱面… = 該面在 CAD 中所在的曲面，圓柱面附其直徑（STL 零件不顯示）；Ø = 等效圓直徑（2·√(area/π)） — 快速的開口尺寸參考，對非圓形面並非實際尺寸；cm² = 面表面積；n = 向外單位法向量。',
    faceReadout:
      '每個面的讀數。平面、圓柱面… = 該面在 CAD 中所在的曲面，圓柱面附其直徑（STL 零件不顯示）；cm² = 面表面積；n = 向外單位法向量。',
    surfaceType: {
      plane: '平面',
      cylinder: '圓柱面',
      cone: '圓錐面',
      sphere: '球面',
      torus: '環面',
      bspline: 'B 樣條曲面',
      other: '其他曲面',
    },
    wallGroup: 'wall（{{count}}）',
    labelSummary: '標籤摘要',
    facesCount: '{{count}} 個面',
    boundaryRolesTooltip:
      'CFD 中各邊界角色的意義：\n• Wall — 固體無滑移表面；流體黏附其上（壁面速度為零）。\n• Inlet — 流體由此進入；由你設定速度/流量。\n• Outlet — 流體由此離開；由你設定壓力（通常為 0 表壓）。\n• Symmetry — 沒有流體穿越的鏡面；可讓你只網格化對稱域的一半。\n• Slip — 無摩擦壁面：沒有流體穿越，但沿壁面也沒有阻力。\n• Farfield / Freestream — 遠離本體、流體不受擾動的開放邊界（外流）。',
    sharedBoundaryNotice: '同名的面會共用一組邊界條件。',
    surfaceZones: '表面區域',
    selectByVolume: '依體積選取面',
    volumeFaces: '體積 {{index}}・{{count}} 個面',
    volumeSelectionHint:
      '在 3D 檢視器中選取屬於此體積的所有表面。下方各面可加入或移出目前選取。',
    selectedFaceName: '命名已選取的 {{count}} 個面',
    faceNamePlaceholder: '例如 symmetry 或 fixed',
    renameSelected: '重新命名',
    surfaceCountTooltip:
      '此零件上偵測到的不同表面數量。即時從伺服器讀取，因此始終與將被網格化的表面一致。',
    loadingSurfaces: '正在載入表面…',
    surfacesNotComputed: '表面尚未計算。請先完成 Diagnosis。',
    // ENG-1816 — rationale on the en key.
    cavityNotExtracted:
      '請先擷取流體空腔。邊界指定是在空腔的面上加標籤，而非實體本體。請先在 Mesh Settings 執行 Extract，再回到這裡。',
    noSurfaces: '沒有可用的表面。請先完成 Diagnosis。',
    // ENG-2361 — 已修正第一句，理由記於 en 鍵。
    noSurfacesWrap:
      '此零件沒有可用的 CAD 面。面清單會在上傳後於背景建立，但部分零件過大或過於複雜而無法完成。名稱仍會在建立網格時套用到包覆表面，請先建立網格，再到網格結果查看哪些名稱成功套用、哪些失敗。',
    // ENG-2361 — 理由記於 en 鍵。
    wrapDescriptorsPending:
      '正在確認此零件的 CAD 面。這會在上傳後於背景執行，通常不到一分鐘；完成後清單會顯示在這裡。',
    surfaceNumberingMismatch:
      '取得的表面清單面編號與此零件不一致，為避免標籤套用到錯誤的面，已停用標籤編輯。請按「重新偵測」重建清單。',
    reDetecting: '重新偵測中…',
    loading: '載入中…',
    reDetect: '重新偵測',
    reDetectFailed: '無法重新偵測表面。請再試一次。',
    noPatchesStl:
      '此 STL 沒有可標記的具名表面（二進位或單一實體的 STL 不含具名表面）。仍可進行網格化；邊界條件會套用至整個表面。若要標記個別 patch，請以含具名實體的 ASCII STL 重新匯出。',
    seedPointTitle: '種子點（選填）',
    seedPointHide: '隱藏種子點標記',
    seedPointShow: '顯示種子點標記',
    seedPointHelper:
      '流體腔體內部的一點，使用模型座標（mm）。簡單形狀會自動偵測；當腔體為非凸形、自動偵測可能落在流體之外時，請手動指定。檢視器中的琥珀色圓點會顯示其位置。',
    seedPointAuto: '自動',
    seedPointUseCenter: '使用零件中心',
  },
  // The four guarded cavity steps in Boundary Assignment on the wrap path (ENG-2465).
  // Copy is the design handoff's copy sheet (Boundary Assignment Wireframes, 3b).
  cavitySteps: {
    // shell — step titles and shared words (ENG-2465)
    detect: '尋找開口',
    nameOpenings: '為每個開口命名',
    nameZones: '為壁面區域命名',
    carve: '切出流體體積',
    carveCoolant: '切出冷卻液',
    optional: '選填',
    // openings — step 2 copy (ENG-2466 appends here)
    // zones — step 3 copy (ENG-2430 appends here)
    zoneNameFor: '面 {{face}} 的名稱',
    wasDetectedOpening: '曾是偵測到的開口',
    // gates — step status, locked reasons and summaries (ENG-2465 PR 2)
    scanning: '正在掃描零件…',
    detectDone_one: '找到 {{count}} 個開口',
    detectDone_other: '找到 {{count}} 個開口',
    skipped_one: '略過 {{count}} 個',
    skipped_other: '略過 {{count}} 個',
    namedCount_one: '已命名 {{count}} 個',
    namedCount_other: '已命名 {{count}} 個',
    openingsNoneNamed: '尚未命名 — 空白會自動填入',
    lockedNeedsDetect: '請先尋找開口。',
    lockedNeedsOpenings: '請先為開口命名。',
    lockedUnmatched_one: '請先清除 {{count}} 個已不適用的已儲存名稱。',
    lockedUnmatched_other: '請先清除 {{count}} 個已不適用的已儲存名稱。',
    lockedNeedsSteps: '請先完成步驟 1–3。',
    lockedNeedsStepsBeforeCoolant: '請先完成步驟 1–2。',
    lockedNamesFirst: '請先清除已不適用的名稱。',
    setGap: '請先設定最窄間隙。',
    carveDone: '已切出流體體積',
    coolantCarveDone: '已切出冷卻液',
    detectAgain: '重新偵測',
  },
  blCoverage: {
    suggestedFix: '建議修正',
    noActionableChanges: '沒有可執行的變更。',
    applied: '已套用',
    applyFix: '套用修正',
    gateRelaxed: '品質門檻已放寬 — 優先確保覆蓋率',
    gateDefault: '預設品質門檻',
    coverage: '覆蓋率',
    coverageWeightedWorst: '加權 {{weighted}}·最差 {{worst}}',
    nearWallAspect: '近壁展弦比',
    nearWallAspectTooltip:
      'snappy 實際在邊界層區域擠出的網格單元展弦比。約 10:1 為健康；30:1 以上表示是被強制達到覆蓋率的。',
    aspectMax: '最大 {{max}}',
    aspectMaxP95: '最大 {{max}}·p95 {{p95}}',
    negVolCells: 'BL 區域內的負體積單元',
    extrudedNothing_one: '{{count}} 個 patch 未擠出任何層：{{patches}}',
    extrudedNothing_other: '{{count}} 個 patch 未擠出任何層：{{patches}}',
    appliedTooltip: '已套用建議的覆寫設定。請重新提交網格以查看效果。',
    applyTooltip: '套用建議的覆寫設定。以右鍵查看前後對照預覽。',
    noLayersExtruded:
      '已要求邊界層，但未擠出任何層 — 所有 wall patch 上都未產生層（通常是網格單元過粗或表面較難處理）。網格無需膨脹層仍可使用；請縮小最小元素尺寸或修復幾何以恢復覆蓋率。',
    patchCount_one: '{{count}} 個 patch',
    patchCount_other: '{{count}} 個 patch',
    layerYield: '層產出率 {{pct}}%',
    allApplied: '全部已套用',
    applyN_one: '套用 {{count}} 項修正',
    applyN_other: '套用 {{count}} 項修正',
    allAppliedTooltip: '已套用所有建議的覆寫設定。請重新提交網格以查看效果。',
    applyNTooltip_one:
      '為 {{count}} 個 patch 套用建議的覆寫設定。防疊加：每項差異都錨定於相同基準。',
    applyNTooltip_other:
      '為 {{count}} 個 patch 套用建議的覆寫設定。防疊加：每項差異都錨定於相同基準。',
    noiseBanner:
      '{{total}} 個 wall patch 中有 {{zeroCount}} 個顯示零覆蓋率 — 許多可能是自動失敗的小型 CAD 特徵（圓角、邊）。可考慮在邊界層面板中標示特定面，將目標限縮至重要的 patch。',
    hoverNeedsTags:
      '游標懸停需要逐面標籤。請開啟邊界層面板，點選表面加以標示，然後重新網格化。',
    hoverUnavailable: '此網格無法使用懸停功能。請重新網格化以啟用。',
    layersCount: '{{achieved}}/{{target}} 層',
  },
  boundaryLayer: {
    title: '邊界層',
    preview: '預覽',
    presetNone: '無',
    presetNoneTitle:
      '完全停用 BL 擠出 — 在不含 addLayers 階段的情況下檢查 hex 網格時很有用。',
    presetStandard: '標準',
    presetStandardTitle:
      '一般 CFD 的 3 層預設。可捕捉概略的 BL 效應；網格化快速。請在求解器中搭配壁面函數使用。',
    // 「解析」在中文 CFD 有歧義（可作「分析/剖析」解），需要壁面數
    // 值解析的語境來對應英文 wall-resolved. 沿用學界慣例「壁面解析」
    // — 直接解析近壁次黏性層 (Y⁺≈1) 而非以壁面函數建模.
    presetResolved: '壁面解析',
    presetResolvedTitle:
      '壁面解析（Y⁺ ≈ 1），適用於 LES / 低 Re RANS。許多薄層，網格與求解較慢，壁面剪應力準確。',
    diagnosisInProgress: 'Diagnosis 進行中',
    diagnosisInProgressBody:
      '用於選取面的 STL 預覽會在 Diagnosis 完成後可用。在此之前，點選以新增 wall 群組不會有作用。',
    pickingOnCavity: '在腔體表面上選取',
    pickingOnCavityBody:
      '內流模式會在擷取出的流體腔體上選取面，而非本體。封蓋面（inlet/outlet）可個別選取。',
    cavityNotRendered: '腔體 STL 尚未繪製',
    cavityNotRenderedBody:
      '腔體 STL 尚未在檢視器中繪出（仍在載入，或抓取/解析失敗）。目前的選取會對應到本體 STL；後端會在提交時將其轉換為腔體面，但模稜兩可的對應可能會被捨棄。請等待腔體繪出，或直接選取並接受轉換風險。',
    picksCleared: '先前的 wall 選取已清除',
    picksClearedBody:
      'wall 群組參照的是先前表面來源的面索引。請在目前的表面上重新標示面以繼續。',
    dismissNotice: '關閉通知',
    noFluidCavity: '尚未擷取流體空腔',
    noFluidCavityBody:
      '邊界層在空腔壁面上生長，但尚未從此零件擷取出流體空腔。請在 Mesh Settings 執行 Extract，或切換為外流。',
    layersGrowInward: '層向流體內部生長',
    layersGrowInwardBody:
      '流體是在 CAD 中建模的，因此稜柱層會從壁面/障礙物表面向周圍流體擠出 — 與擷取出的腔體相同，是向內方向，而非像外流那樣向外。',
    description: '在壁面附近的稜柱層，可在 CFD 中準確解析邊界層。',
    sectionLabel: '邊界層',
    on: '開',
    off: '關',
    wallGroupsSelected: '已選取用於稜柱層膨脹的 wall 群組。',
    groupsShort: '{{count}} 組',
    triShort: '{{value}} 三角',
    areaShort: '{{value}} 面積',
    layerInputModeTooltip:
      '設定第一層網格單元高度（y₀）的兩種方式。預設：輸入 y₀、層數與生長比。\nY+ 計算：由目標 y⁺（第一層網格單元距離壁面的遠近）以及流速、長度和流體求出，以覆蓋紊流模型所需的範圍。\ny⁺≈1 可解析壁面，30~300 則用於壁面函數。',
    layerInputMode: '層輸入模式',
    yPlusCompute: 'Y+ 計算',
    defaults: '預設',
    globalDefaults: '全域預設',
    firstCellHeight: '第一層網格單元高度 y₀',
    firstCellHeightYPlusTitle:
      '由下方的 y+ 計算機驅動 — 關閉 y+ 開關即可直接編輯。單位選擇器仍可使用，並與計算機讀數共用。',
    firstCellHeightTitle:
      '稜柱層堆疊的第一層壁面法向高度。無論顯示單位為何，提交值皆為 mm。輸入 -1 或「auto」可讓求解器自動決定。',
    autoInitialHeight: 'auto',
    layerCount: '層數 N',
    growthRatio: '生長比 r',
    totalThickness: '總厚度',
    fluidDensity: '流體密度',
    fluidPresetTooltip:
      'y+ 計算的參考流體。Air 和 Water 使用其 20 °C / 1 atm 的運動黏度。Custom ρ 可讓你直接輸入 ν。',
    customDensityLabel: 'Custom ρ',
    customNuTitle:
      '運動黏度 ν = μ/ρ。20 °C 時空氣約 1.5e-5 m²/s，水約 1.0e-6 m²/s。',
    yPlusTarget: 'y+ 目標',
    yPlusTargetPlaceholder: '例如 1',
    yPlusTargetTitle:
      '第一層網格單元距離壁面的遠近 — y⁺ 是無因次的壁面距離（並非能量項）。使用 ≈1 可直接解析邊界層（低 Re RANS / LES），或在依賴壁面函數時使用 30~300。我們會依你在下方設定的流速、長度和流體，把 y⁺ 轉換成第一層網格單元高度。',
    velocity: '速度 U∞',
    velocityPlaceholder: '例如 10',
    velocityTitle: '外流為自由流速度，內流為主流速度。用於計算 Re = U·L/ν。',
    charLength: '特徵長度 L',
    along: '沿',
    charLengthAxisInternalTooltip: '內流 — 選擇代表水力尺寸的軸',
    charLengthAxisTooltip: '選擇用來設定 L 的 CAD 邊界',
    charLengthTitle:
      '計算 Re 的特徵長度。預設為所選軸（X / Y / Z）方向的 CAD 邊界盒；輸入數值可覆寫。單位與包圍盒面板共用。',
    totalThicknessReadout: '總厚度 =',
    layerCountReadout: '層數 N =',
    laminarWarning:
      'Re < {{threshold}} — 流動為層流。此處使用的 Cf 相關式適用於紊流，因此 y₀ 可能不準確；請考量在此 Re 下是否需要壁面解析的 BL。',
    transitionWarning: '過渡 Re — Cf 相關式的準確度下降；請將 y₀ 視為估計值。',
    advancedAddLayers: '進階（snappy addLayers）',
    readOutLengthUnit: '讀數長度單位',
    carvedWallLayers: '萃取壁面的邊界層',
    wallGroups: 'Wall 群組',
    deleteSelected: '刪除所選',
    globalActive: '全域 BL 啟用中 — 所有群組使用全域預設',
    globalPopulate: '填入所有幾何面並統一套用全域預設',
    global: '全域',
    selectAll: '全選',
    selectAllTooltip: '全選（Ctrl+A）',
    addFromViewer: '在檢視器中點選一個表面即可加入此處。',
    confirmRemove: '點選以確認移除',
    clickToSelect: '點選以選取',
    clickToRename: '點選以重新命名',
    // 「三角面片」= STL tessellation facets. 單獨的「三角」易誤讀
    // 為幾何學名詞, 補上「面片」讓網格化語境明確 (每個 face 由多
    // 少個三角面片離散).
    triCount: '{{value}} 三角面片',
    // 「面積」保留字面即可; 上下文已在群組列, 讀者自明.
    areaCount: '面積 {{value}}',
    clickAgainToRemove: '再次點選以移除',
    globalRow: '全域',
    applyAndBack: '套用並返回網格',
    unitLabel: '單位',
    regimeLaminar: '層流',
    regimeTransition: '過渡',
    regimeTurbulent: '紊流',
  },
  embeddedFluid: {
    roleFluid: '流體',
    roleWall: '壁面',
    roleExclude: '排除',
    roleFluidHint: '屬於流動域的一部分。至少須有一個本體為流體。',
    roleWallHint: '流動中的障礙物 — 其表面成為流體的無滑移壁面。',
    roleExcludeHint:
      '完全移除該本體。僅適用於不接觸流動的零件（緊固件等）。若它與流體共用表面，請使用「壁面」。',
    internalFlowStyle: '內流方式',
    singleBodyHint:
      '此零件只有單一本體，沒有可分類的對象 — 內嵌流體需要多本體組件（流體本體＋固體障礙物）。流體擷取會自動導出腔體。',
    fluidExtraction: '流體擷取',
    embeddedFluid: '內嵌流體',
    stlUnsupported:
      '內嵌流體需要多本體的實體 CAD 檔案（STEP/BREP）。不支援 STL — 請改用流體萃取，或以 STEP 重新上傳。',
    embeddedDescription:
      '流體是在 CAD 中建模的。請在下方將每個本體分類為流體或壁面障礙物；障礙物會成為無滑移壁面。',
    extractionDescription:
      '流體腔體是從封閉固體擷取而來的。請在下方標示 inlet/outlet 面。',
    bodies: '本體（{{count}}）',
    markOneFluid: '請將至少一個本體標示為流體 — 流動需要一個域。',
    bodyLabel: '本體 {{index}}',
  },
  enclosure: {
    hideEnclosure: '隱藏包圍盒',
    showEnclosure: '顯示包圍盒',
    enclosure: '包圍盒',
    openGeometry_one:
      '開放幾何（{{count}} 條邊界邊）。域的放置可能不可靠。若為內流（管道、外殼），請將所有係數設為 0。',
    openGeometry_other:
      '開放幾何（{{count}} 條邊界邊）。域的放置可能不可靠。若為內流（管道、外殼），請將所有係數設為 0。',
    displayInTooltip: '以 {{unit}} 顯示（CAD 來源：{{source}}）。右鍵可變更。',
    unitsInferredTooltip:
      '單位由 STEP 檔頭推斷得出（{{unit}}）。右鍵可變更顯示單位。',
    noUnitTooltip: 'STEP 檔頭找不到單位 — 右鍵可設定顯示單位。',
    displayUnits: '顯示單位',
    fromCad: '來自 CAD',
    unknownUnit: '未知',
    unitPlaceholder: '單位？',
    // 「上游/下游/側向」— 外流風洞語境:
    //  · 上游 (Upstream)   = inlet 側, 流體來源
    //  · 下游 (Downstream) = outlet 側, 流體離開
    //  · 側向 (Lateral)    = 與流動方向垂直的兩對側面 (通常為壁面)
    roleUpstream: '上游',
    roleDownstream: '下游',
    roleLateral: '側向',
  },
  snappyFields: {
    // snappyHexMesh 網格品質 / addLayers 邊界層擠出參數的
    // 標籤 + 說明. 學術/CFD 慣用譯法; 保留關鍵英文縮寫如
    // FV / BL 因為技術文獻沿用.
    rangeSuffix: '預設值：{{default}} · 嚴格 {{strict}} / 寬鬆 {{permissive}}',
    // 「非正交角」= 相鄰單元中心連線與共面法向的夾角, 單位度
    maxNonOrthoLabel: '最大非正交角',
    maxNonOrthoDesc:
      '面的最大非正交角（°）。數值越高接受越多單元, 求解器精度下降。是可靠性的主要調節旋鈕。',
    // 「歪度/扭曲度」skewness 的中文慣例; 對應「內部面/邊界面」
    maxInternalSkewLabel: '最大內部面歪度',
    maxInternalSkewDesc: '內部面的最大歪度。高於此值的單元會被拒絕。',
    maxBoundarySkewLabel: '最大邊界面歪度',
    maxBoundarySkewDesc: '邊界（壁面）面的最大歪度。壁面單元容許較大歪度。',
    // 「凹角」單元的最大凹陷角
    maxConcaveLabel: '最大凹角',
    maxConcaveDesc: '單元凹陷角的最大值（°）。',
    minVolRatioLabel: '最小體積比',
    minVolRatioDesc: '相鄰單元的最小體積比。越低則允許尺寸突變。',
    // 「面權重」在有限體積 (Finite Volume) 中即內插權重
    minFaceWeightLabel: '最小面權重',
    minFaceWeightDesc: '最小內插權重 — 影響有限體積法離散精度。',
    // face twist = 面的扭曲度指標
    minTwistLabel: '最小面扭曲度',
    minTwistDesc: '面的最小扭曲度。',
    // determinant = 單元變換矩陣的行列式, 用來過濾接近退化的單元
    minDeterminantLabel: '最小行列式值',
    minDeterminantDesc: '單元行列式的最小值（過濾接近退化的單元）。',
    // 「放寬」= relaxed 於此指主門檻失敗後的備援
    relaxedMaxNonOrthoLabel: '放寬版最大非正交角',
    relaxedMaxNonOrthoDesc:
      '主門檻失敗時的備援非正交角上限 — snappy 會以此較寬鬆的界限重試。',
    // 「層厚度比」= layer thickness ratio; 「中軸」= medial axis
    maxFaceThicknessRatioLabel: '最大層厚度比',
    maxFaceThicknessRatioDesc:
      '邊界層擠出時, 層厚度與相鄰面厚度的最大比。值越大越能於曲面（面厚度變化大）上鋪出邊界層。',
    maxThicknessToMedialLabel: '厚度/中軸比上限',
    maxThicknessToMedialDesc: '層厚度與局部中軸距離的最大比。',
    minMedialAxisAngleLabel: '最小中軸夾角',
    minMedialAxisAngleDesc:
      '當中軸夾角低於此值（度）, snappy 視為過於狹窄而拒絕擠出。',
    // n_layer_iter = addLayers 的外層迭代次數
    nLayerIterLabel: '層迭代次數',
    nLayerIterDesc:
      'addLayers 中「擠出 → 檢查品質 → 放寬 → 重試」的最大外層迭代次數。',
    nRelaxedIterLabel: '放寬迭代次數',
    nRelaxedIterDesc: 'addLayers 切換至放寬品質限制後的次迭代次數。',
  },
  engineOverrides: {
    beta: 'Beta',
    snapToFeatureEdges: '對齊 CAD 特徵邊',
    snapToFeatureEdgesHelper:
      '網格化時將網格頂點直接拉到 CAD 特徵曲線上 — 在大多數幾何上可得到更銳利、更乾淨的邊。',
    polishSnappedEdges: '拋光已對齊的邊',
    polishSnappedEdgesHelper:
      '對齊後，將殘留的近邊頂點推移到 CAD 曲線上，以平滑鋸齒狀的邊。搭配開啟「對齊 CAD 特徵邊」效果最佳。',
    engineOverrides: '引擎覆寫',
    presetFast: '快速',
    presetFastTitle:
      '近壁較粗，在一般幾何上約 30 秒完成網格。用於初次驗證或除錯邊界條件 — 物理結果會不準確。',
    presetStandard: '標準',
    presetStandardTitle:
      '典型 CAD 的案例實證基準（feature_angle 120°、n_smooth_patch 5、snap 迭代 100/10）。細化層級維持 Auto — 後端會依幾何複雜度限制範圍。',
    presetFine: '精細',
    presetFineTitle:
      '銳利特徵的量產級 CFD — 單元數多 5~10 倍。用於葉片、翅片、銳利前緣等近壁準確度重要之處。',
    refineInverted:
      'Refine Level Min（{{min}}）> Refine Level Max（{{max}}）。後端會拒絕此設定 — 請對調兩者。',
    refineMaxHigh:
      'Refine Level Max {{max}} ≈ {{factor}}× 壁面單元 — 大型 L6+ 網格可能執行數十分鐘，並超過預設的 30 分鐘策略逾時。若網格化緩慢，請提高策略逾時。',
    snapFidelity: 'Snap 保真度',
    edgeRecoveryTip: '提示：也開啟「拋光已對齊的邊」以獲得最乾淨的結果。',
    snappyQuality: 'Snappy 品質',
    presetAdvanced: '進階',
    presetAdvancedTitle:
      '收緊每個接受門檻 — 研究級。當 CAD 乾淨時可得到最佳求解器準確度，但網格器可能拒絕更多單元。僅在你有已知良好的案例時再從此開始。',
    presetRelaxed: '寬鬆',
    presetRelaxedTitle:
      '放寬接受門檻 — 在曲面或銳利幾何上反覆網格化失敗時很有用。網格會完成；但求解器準確度可能下降。',
    presetReset: '重設',
    presetResetTitle:
      '將所有 snappy 品質 + addLayers 旋鈕重設為 Auto。後端會使用其經驗證的平衡預設值。',
    cellBudget: '單元預算',
    cellBudgetHint:
      'L4 以上每提高一個細化層級，預設值放大 2 倍。釘選數值可覆寫。',
    addLayers: 'Add Layers',
    prioritizeBlCoverage: '優先確保 BL 覆蓋率',
    prioritizeBlCoverageHelper:
      '接受品質下降（但仍有效）的單元，以換取更多邊界層覆蓋率。這是放寬層門檻的驗證方式 — 請優先使用此項而非 Snappy 品質的「寬鬆」預設。預設為關。',
    advancedOverrides: '進階覆寫',
    bypassDirtyCad: '略過髒 CAD 前置檢查門檻',
    bypassDirtyCadHelper:
      '讓自相交或非水密的幾何能進入網格化，而不會在一開始就被擋下。預設為開，執行一律嘗試網格化；若要重新啟用前置檢查門檻、在浪費網格器時間前擋下髒 CAD，請取消勾選。',
    fieldSmoothing: '平滑化',
    fieldAlgorithm2d: '2D 演算法',
    fieldAlgorithm3d: '3D 演算法',
    fieldGrading: '漸變',
    fieldOptPasses: '最佳化次數',
    fieldCurvatureSafety: '曲率安全係數',
    fieldSegmentsPerEdge: '每邊段數',
    fieldRefineLevelMin: '最小細化層級',
    fieldRefineLevelMax: '最大細化層級',
    fieldFeatureAngle: '特徵角度',
    fieldCellsBetweenLevels: '層級間單元數',
    fieldResolveFeatureAngle: '解析特徵角度',
    fieldSmoothPatch: '平滑 patch',
    fieldBlockmeshCellSize: 'BlockMesh 單元尺寸',
    fieldSnapSolveIter: 'Snap 求解迭代',
    fieldFeatureSnapIter: '特徵 snap 迭代',
    fieldSnapTolerance: 'Snap 容差',
    fieldMeshSizeFine: '網格尺寸（細）',
    fieldMeshSizeCoarse: '網格尺寸（粗）',
    fieldMeshSizeFarfield: '網格尺寸（遠場）',
    fieldMaxLocalCells: '本地最大單元數',
    fieldMaxGlobalCells: '全域最大單元數',
    tipSmoothing:
      '網格化後套用的拉普拉斯平滑次數，用於提升單元品質。次數越多越平滑但越慢。預設：Auto。',
    tipAlgorithm2d:
      'Gmsh 的 2D 表面網格化演算法（數值代碼 — 例如 6 = Frontal-Delaunay）。除非此零件的表面網格化有困難，否則維持 Auto。',
    tipAlgorithm3d:
      'Gmsh 的 3D 體積網格化演算法（數值代碼 — 例如 10 = HXT，高速平行 Delaunay）。預設：Auto。',
    tipGrading:
      '單元尺寸從細到粗成長的速度。接近 1.0 幾乎均勻；越大則越快變粗、單元數越少。預設：Auto。',
    tipOptPasses:
      '網格化後的最佳化次數，用於解開並改善品質不佳的四面體。次數越多品質越好但網格化越慢。預設：Auto。',
    tipCurvatureSafety:
      '曲面被細化的積極程度 — 越大則以更小的單元解析曲率（單元數增加）。預設：Auto。',
    tipSegmentsPerEdge:
      '沿每條 CAD 邊的最小網格分段數。若要解析短邊與小特徵請調高。預設：Auto。',
    tipRefineLevelMin:
      '本體上的最小表面細化層級。每 +1 會在局部使壁面單元尺寸減半。預設：Auto（依 min_size）。可嘗試 2~3。',
    tipRefineLevelMax:
      '最大表面細化。每 +1 約使該區域單元數增為 8 倍。控制近壁細節的主要旋鈕。預設：Auto（依 min_size）。可嘗試 4~6。',
    tipFeatureAngle:
      '二面角（°），低於此值的邊會被視為銳利特徵並額外細化。越低捕捉越多邊。預設：150°。可嘗試 30°（銳利）、60°（輕微）。',
    tipCellsBetweenLevels:
      '細化層級之間過渡區的緩衝單元數。越高漸變越平滑、傾斜單元越少。預設：3。可嘗試 3~5。',
    tipResolveFeatureAngle:
      'snap 階段將網格鎖定至偵測特徵的角度門檻（°）。越低越積極進行角落對齊。預設：30°。可嘗試 15~30°。',
    tipSmoothPatch:
      '對齊後的表面網格平滑迭代次數。越高 patch 越平滑但越慢。預設：3。可嘗試 3~5。',
    tipBlockmeshCellSize:
      '背景 hex 邊長（mm）。設定細化前的基準；其餘皆相對於此。預設：Auto（約本體/30）。可嘗試本體長度的 5~10%。',
    tipSnapSolveIter:
      'snap 階段期間的求解器迭代次數。越高壁面貼合越好但越慢。預設：30。可嘗試 30~50。',
    tipFeatureSnapIter:
      '專用於將網格對齊特徵邊的迭代次數。預設：5。銳利幾何可嘗試 5~10。',
    tipSnapTolerance:
      'snap 位移容差（× 單元尺寸）。越低對齊越緊（反轉單元風險較高）；越高對齊越鬆（表面貼合較差）。預設：2.0。可嘗試 1.0~5.0。',
    tipMeshSizeFine:
      '壁面 STL 三角尺寸（mm）。設定網格器進一步細化前輸入表面的細緻程度。預設：½ × min_size。',
    tipMeshSizeCoarse:
      '遠離特徵處的 STL 三角尺寸（mm）。預設：2× 細。可嘗試 2~5× 細。',
    tipMeshSizeFarfield:
      '包圍盒上的三角尺寸，也是整個計算域的背景單元尺寸（mm）。它對總單元數的影響最大 — 應調粗而非調細。預設：Auto（約 body/7）。',
    tipMaxLocalCells:
      '細化期間每個並行工作者保有的最大單元數。預設值隨 Refine Level Max（L{{level}}）縮放：{{value}}。釘選數值可覆寫。',
    tipMaxGlobalCells:
      '細化期間的總單元數上限。預設值隨 Refine Level Max（L{{level}}）縮放：{{value}}。高細化 L6 扇形可能需要 ≥ 16M。釘選數值可覆寫。',
    autoDerivedSize:
      '此欄位設為自動時，會解析為約 {{value}} mm。網格器可能會依你的幾何形狀調整。',
    autoDerivedLevel:
      '此欄位設為自動時，會依你的網格尺寸解析為約層級 {{value}}。網格器可能會依你的幾何形狀調整。',
  },
  generatingMesh: {
    generatingMesh: '正在產生網格',
  },
  meshExport: {
    export: '匯出',
  },
  refinement: {
    localRefinement: '適應性細化',
    sicnThreshold: 'SICN 門檻（細化低於此值的元素）',
    targetSize: '目標尺寸（mm，選填）',
    submitting: '提交中…',
    refineMesh: '細化網格',
    failedToSubmit: '提交失敗',
  },
  refinementZones: {
    title: '局部細化',
    stepSummary_one: '{{count}} 個區域',
    stepSummary_other: '{{count}} 個區域',
    entryHint: '在檢視器中放置方塊，細化其中的網格',
    hexOnly: '僅限 Hex 或 Poly 網格',
    description:
      '在需要更細網格的位置放置方塊 — 狹窄通道、尾流、噴流。每個區域內的網格會細化到目標尺寸，其餘部分保持較粗。',
    zonesHeader: '區域',
    addBox: '新增方塊',
    addSphere: '新增球體',
    addWaitingForModel: '正在等待模型載入…',
    empty: '尚無區域。新增一個方塊來細化局部網格。',
    zoneSummaryBox: '方塊 · {{dims}} mm',
    zoneSummarySphere: '球體 · r={{radius}} mm',
    showInViewer: '在檢視器中顯示',
    hideInViewer: '在檢視器中隱藏',
    hiddenStillApplies: '已在檢視器中隱藏 — 產生網格時仍會套用。',
    renderBudgetExceeded:
      '區域太多，無法全部顯示 — 多出的區域產生網格時仍會套用。',
    deleteZone: '刪除區域',
    renameZone: '區域名稱',
    boxDefinition: '方塊定義',
    sphereDefinition: '球體定義',
    modeCenterSize: '中心＋尺寸',
    modeMinMax: '最小 / 最大',
    centerMm: '中心（mm）',
    sizeMm: '尺寸（mm）',
    minPointMm: '最小角點（mm）',
    maxPointMm: '最大角點（mm）',
    radiusMm: '半徑（mm）',
    targetCellSize: '目標網格尺寸',
    centerTip: '方塊在模型座標中的位置。',
    sizeTip: '方塊沿各軸的大小。',
    minPointTip: 'X、Y、Z 最小的角點 — 在檢視器中以琥珀色標示。',
    maxPointTip: 'X、Y、Z 最大的角點 — 在檢視器中以青色標示。',
    radiusTip: '球體自中心延伸的距離。',
    targetCellSizeTip: '此區域內想要的網格尺寸，會對齊到最接近的細化層級。',
    refinementLevel: '細化層級',
    refinementLevelTip:
      '每一層級都會將背景網格（{{blockmesh}} mm）減半，網格以 2 的冪次細化。目標值會對齊到最近的層級。點擊層級可將目標設為該網格尺寸。',
    effectiveOk: '層級 {{level}} 的實際尺寸為 {{size}} mm',
    cappedTitle: '層級 {{level}} 無法達到目標',
    cappedDetail:
      '您要求 {{target}} mm，但最大細化層級（{{level}}）在此只能達到 {{effective}} mm。提高層級才能達到目標。',
    raiseLevel: '將最大細化層級提高到 {{level}}',
    beyondMaxLevel:
      '{{target}} mm 的目標需要層級 {{level}}，超過上限 8。請改用較粗的目標。',
    coarserThanBase:
      '目標比背景網格（{{blockmesh}} mm）更粗，此區域不會增加細化。',
    sizesUnknown: '網格尺寸預覽需要幾何邊界 — 請先執行診斷。',
    approxNote: '尺寸為估計值 — 網格產生器可能會依網格數量預算調整。',
    presets: '預設',
    fitToDomain: '貼合整個流域',
    fitToFaceHint: '點擊檢視器中的一個面，讓所選區域包住該面。',
    done: '完成',
    cancel: '取消',
  },
  meshSource: {
    label: '網格來源',
    fluidDomain: '流體域',
    body: '本體',
    tip: '要檢視、選取並產生網格的表面。流體域＝抽取的空腔；本體＝CAD 表面 — 當上傳檔案本身就是流體體積時使用。',
  },
  overrideInput: {
    auto: 'Auto',
  },
  qualityTarget: {
    qualityTarget: '品質目標',
    off: '關',
    offTitle: '不設定網格後品質門檻',
    // 「寬鬆/標準/嚴格」— 由鬆到緊的三檔預設. 沿用平時 CFD 網格
    // 語境的用詞而非直譯 (Loose/Tight 直譯「鬆/緊」單獨看不易辨識).
    presetLoose: '寬鬆',
    presetStandard: '標準',
    presetTight: '嚴格',
    // Tet 的品質度量 SICN (Signed Inverse Condition Number, 0~1)
    // 是行內術語, 保留英文縮寫; 說明句以「最小值」點明方向.
    tetLabel: 'SICN 最小值',
    tetHint: '數值越高越嚴格 (0~1)。優化器會反覆平滑直到最差單元的 SICN 達標。',
    tetDescription:
      '網格後品質門檻。四面體優化器會執行額外的平滑迭代，直到最小 SICN 達到目標。',
    // Max Non-Orthogonality (最大非正交角, 相鄰單元中心連線與共面法
    // 向的夾角) — 學界慣例「非正交角」, 單位度.
    hexLabel: '最大非正交角 (°)',
    hexHint: '數值越低越嚴格 (度)。若最大非正交角未達標則會重新網格化。',
    hexDescription:
      '網格後品質門檻。snappyHexMesh 會以更嚴格的控制項重新執行，直到最大非正交角達到目標。',
    polyDescription:
      '網格後品質門檻。cfMesh 會以更嚴格的控制項重新產生網格，直到最大非正交角達到目標。',
  },
  geometryHealth: {
    errorTimeout: '幾何太複雜而無法分析。請嘗試簡化模型或移除小型特徵。',
    errorSegfault:
      '幾何包含無法處理的特徵。請檢查是否有損壞的表面或重疊的本體。',
    errorOom: '幾何太大而無法分析。請嘗試減少本體數量或拆分組件。',
    errorAbort: '無法讀取幾何格式。請嘗試從你的 CAD 工具重新匯出檔案。',
    errorNoResult:
      '分析已完成，但無法擷取拓撲資料。請嘗試將檔案重新匯出為 STEP。',
    errorZeroVolume:
      '此幾何沒有實體體積 — 它可能是表面本體或草圖。網格化需要封閉的固體。',
    errorNoGeometry:
      '檔案中找不到幾何。檔案可能是空的、只含點或曲線，或使用不支援的格式。',
    errorGeneric: 'Diagnosis 失敗。請嘗試重新上傳檔案。',
    errorFallback:
      '無法分析幾何。請嘗試在啟用「修復幾何」的情況下，從你的 CAD 工具重新匯出。',
    dimensionalTooltipWithUnit:
      'Diagnosis 期間偵測到的原始 CAD 單位：{{unit}}。數值以 mm 顯示（OCC 的內部工作單位）。',
    dimensionalTooltipNoUnit:
      'CAD 檔頭未宣告單位 — 數值以 mm 顯示（OCC 的內部工作單位）。請在「Mesh Settings → Units」中選擇來源單位。',
    countVol: '{{count}} 實體',
    countSurf: '{{count}} 表面',
    countCurv: '{{count}} 曲線',
    diagValue: '{{value}} mm 對角線',
    surfaceAreaValue: 'SA {{value}} mm²',
    manifold: '流形',
    watertight: '水密',
    geometryClean: '幾何乾淨',
    noIssuesFound: '未發現拓撲或品質問題',
    blockingTitle: '阻擋 · 必須修正',
    blockingFootnote: '拓撲錯誤 — 網格化可能失敗或產生不良單元。建議修復 CAD。',
    qualityTitle: '品質 · 建議',
    qualityFootnote: '通常可透過選擇更細的網格尺寸來解決。',
    shownInViewer: '在檢視器中顯示 {{shown}}/{{total}}',
    showAll: '顯示全部',
    noPerIssueDetails: '此幾何未回傳逐項問題的詳細資料。',
    showInViewer: '在檢視器中顯示',
    hideInViewer: '在檢視器中隱藏',
    showLayerInViewer: '在檢視器中顯示 {{label}}',
    hideLayerInViewer: '在檢視器中隱藏 {{label}}',
    askAi: '詢問 AI',
    askAiTooltip: '向 AI 詢問關於此幾何的問題',
    uploadToRunDiagnosis: '上傳檔案以執行 Diagnosis',
    diagnosingGeometry: '正在診斷幾何…',
    detailedIncomplete: '詳細 Diagnosis 未完成',
    diagnosisFailed: 'Diagnosis 失敗',
    detailedIncompleteBody: '健康檢查未完成，但幾何預覽可用，仍可繼續網格化。',
    noDiagnosisAvailable: '沒有可用的 Diagnosis',
    repairingNewVersion: '正在修復新版本…',
    diagnosingNewVersion: '正在診斷新版本…',
    uploading: '上傳中…',
    uploadFixedVersion: '上傳修正版本',
    title: '幾何健康',
  },
  repairHistory: {
    issueManifoldEdge: '非流形邊',
    issueManifoldVertex: '非流形頂點',
    issueWatertight: '邊界間隙',
    issueWinding: '面繞向不一致',
    issueZeroLengthEdge: '零長度邊',
    issueSelfIntersection: '自相交',
    issueOverlappingFace: '重疊面',
    issueDegenerateFace: '退化面',
    fullyRepaired: '完全修復',
    partiallyRepaired: '部分修復',
    repairFailed: '修復失敗',
    repairNotKept: '未保留',
    repairAttempted: '已嘗試修復',
    fixed: '已修正 {{labels}}',
    removed: '已移除：{{items}}',
    diagnosing: '診斷中…',
    repairing: '修復中…',
    current: '（目前）',
    viewVersion: '檢視版本 {{version}}',
    viewVersionCurrent: '檢視版本 {{version}}（目前）',
    downloadVersion: '下載版本 {{version}} 的原始檔',
    downloadTooltip: '下載此版本的原始檔',
    title: '修復歷史（{{count}} 個版本）',
    originUpload: '上傳',
    originAutoRepair: '自動修復',
    originManualRepair: '修復',
    originManualUpload: '手動上傳',
    originCadMorph: 'CadMorph',
    failureCadMorphRejected: 'CAD 變更已拒絕',
    originCadSimplify: 'CAD 簡化',
    failureSimplifyRejected: '已拒絕簡化',
    failureRepairFailed: '修復失敗',
    failureDiagnosisFailed: 'Diagnosis 失敗',
  },
  snapFidelity: {
    surfaceDev: '表面偏差（平均 / 最大）',
    surfaceDevHint:
      '已網格化的表面距離 CAD 表面有多遠 — 平均與最壞情況距離。越小表示越貼合原始幾何。',
    featureCapture: '特徵捕捉（≤ 0.5 單元）',
    featureCaptureHint:
      '落在其真實位置半個單元寬度內的 CAD 特徵邊比例。越高表示銳利邊已對齊到應在的位置。',
    resolvableFeatures: '可解析的特徵',
    resolvableFeaturesHint:
      '目前單元尺寸精細到足以解析的 CAD 特徵邊比例。數值低表示網格太粗而無法對齊 — 請先縮小最小元素尺寸。',
    snapConverged: 'Snap 已收斂',
    snapConvergedHint:
      '網格器的邊對齊迭代是否已穩定。「否」表示有些邊始終未鎖定到 CAD 特徵；任何殘留的非法面會一併顯示。',
  },
  submitButton: {
    blockedTooltip: '有一項或多項設定錯誤阻擋提交。請解決上方標示的項目。',
    fixValidationErrors: '請修正上方的驗證錯誤',
    preparing: '準備中…',
    generateMesh: '產生網格',
  },
  validation: {
    cellCoarserThanPassage:
      '請改為 {{target}} mm 或更小——{{minSize}} mm 對流道而言過粗。',
    chtNeedsCavity: '請先擷取冷卻液空腔，共軛分析需要流體成為獨立實體。',
    chtNeedsFluidBody: '請在實體分類中將冷卻液實體標記為流體。',
    noFluidCavityWarning:
      '未為此幾何擷取流體腔體（通常是髒或未修復的本體）。請修復本體並重新執行 Diagnosis，或切換為外流，以取得可靠的腔體網格。',
    noWrapCavity:
      '尚未從此部件切出流道腔體。請先執行流體擷取步驟，再送出網格。',
    noWrapChtCarve:
      '建立網格前請先切出冷卻液。開啟邊界指定，找出開口後再切出。',
    embeddedNeedsHex:
      '內嵌流體需要 hex 網格 — 四面體的內嵌流體執行會被求解器拒絕。請將 Element Type 切換為 Hex。',
    pickUnit:
      '請為此幾何選擇單位 — 目前尚無可用的 CAD 邊界。Diagnosis 完成後，請使用上方的 Units 選單。',
    seedPointRequired:
      'STL 內流網格需要在流體腔體內設定種子點 — 網格器無法從 STL 自動找到它。請在 Boundary Assignment 中設定。',
    chtPassageRequired:
      '要網格化從內部冷卻的零件，請在邊界指定中輸入最窄通道寬度 — 找出開口後會自動填入。抽取程序無法自行推斷，比網格單元更細的通道會被封閉。',
    flowPassageRequired:
      '要從此零件切出流體腔體，請輸入最窄通道寬度 — 抽取程序無法自行推斷，比網格單元更細的通道會被封閉。',
    passagePositive: '最窄通道必須大於 0 mm。',
    partsWillBeNamed: '零件將命名為 {{names}}。',
    partCheckRunning:
      '仍在檢查此上傳檔案是否有獨立零件。現在網格化，零件將命名為 part_0、part_1 等；也可以等待檢查完成後自行命名。',
    fixPartNames: '請在本體分類中修正這些名稱：{{names}}。',
    blankName: '空白名稱',
    estCells: '預估',
    cellsMeshTime: '單元 ·',
    meshTimeSuffix: '網格時間',
    warningCount_one: '{{count}} 個警告',
    warningCount_other: '{{count}} 個警告',
    hintCount_one: '{{count}} 個提示',
    hintCount_other: '{{count}} 個提示',
    jumpToInput: '點選以跳至相關輸入',
    // 網格參數提交前的檢核提示. 分 error/warning/info 三級. 保留
    // CFD/CAD 術語 (SICN、y+、mesher、addLayers、feature edges) 因
    // 為使用者搜尋文獻時是以英文為關鍵字.
    refineMinHigherThanMax:
      '細化層級下限（{{min}}）高於細化層級上限（{{max}}）。請將下限調低或上限調高。',
    internalFlowEnclosureConflict:
      '「內流」與「外部包圍盒」不能同時啟用。請關閉包圍盒, 或將流動類型切換為「外流」。',
    meshSizeFineTooLarge:
      '細部壁面 STL 尺寸（{{fine}}）必須小於最大尺寸（{{max}}）。',
    relaxedNonOrthoLowerThanMain:
      '放寬版最大非正交角（{{relaxed}}）不能低於最大非正交角（{{main}}）。',
    hexOnlyFirstOrder: '六面體網格僅支援一階單元 — 請將單元階數設為 1。',
    externalStlNoTet:
      '外部流動下，STL 曲面無法使用四面體網格 — 請將單元類型設為 Hex 或 Poly。',
    wrapExternalHexOnly:
      '外部流動下，包覆曲面僅支援六面體網格 — 請將單元類型設為 Hex。',
    wrapChtHexOnly:
      '包覆零件的共軛傳熱僅支援六面體網格 — 請將單元類型設為 Hex。',
    repairChtTetOnly:
      '修復零件的共軛傳熱僅支援四面體網格 — 請將單元類型設為 Tet。',
    refineMaxHigh:
      '細化層級上限 {{max}} 大約會產生 {{factor}} 倍的壁面單元數。請設定單元數上限, 否則網格化時間會很長。',
    cellsBetweenLevelsLow:
      '過陡的細化過渡會產生歪斜單元。層間單元數至少設為 3。',
    featureAngleLow: '過低的特徵角會使平滑曲面被過度細化。常用範圍為 30~60°。',
    maxNonOrthoHigh:
      '超過 80° 時求解器經常發散 — 建議將最大非正交角設在 80 以下。',
    relaxedNonOrthoHigh: '超過 85° 時壓力求解易崩壞 — 建議此值設在 85 以下。',
    blGrowthRateHigh: '生長比高於 1.5 會使邊界層到主體網格的過渡過於突兀。',
    blThickStackLowGrowth:
      '層厚 + 低生長比可能無法容納於壁面與細化區之間 — 請減少層數或提高生長比。',
    blStackTallerThanMinSize:
      '邊界層總厚度（{{stack}} mm）高於最小尺寸（{{minSize}} mm） — 各層會溢入主體網格。請減少層數、降低第一層高度, 或放寬最小尺寸。',
    blStackVsOpeningDiameter:
      '邊界層總厚度（{{stack}} mm）超過最小開口直徑（{{diameter}} mm）的 10 % — 相對壁面的邊界層在凹角會相撞。請減少層數或降低第一層高度。',
    blFirstLayerLargerThanMinSize:
      '第一層高度（{{height}} mm）大於最小尺寸（{{minSize}} mm） — 每層都比周圍單元還大, 沒有邊界層解析度可言。',
    blFirstLayerFarSmallerThanMinSize:
      '第一層高度低於最小尺寸的 0.1 % — 這種尺度差需要不切實際的細化程度才能解析。',
    blSingleLayer: '僅 1 層 — 等同於沒有邊界層。',
    blManyLayers: '{{count}} 層邊界層並不常見 — 通常 8 層以上已足夠。',
    blGrowthRateLow:
      '生長比低於 1.05 會產生近乎等厚的層 — 需要很多層才能達到主體單元尺寸。',
    // 中文無單複數變化, 兩個 key 指同一句以滿足 i18next 的 count 分岔.
    blSliverTargets_one:
      '{{count}} 個邊界層目標面（{{labels}}）表面積低於 {{threshold}} mm²。這些面過小無法乾淨網格化 — 網格器多半會捨棄它們, 並撕裂鄰近邊界層。',
    blSliverTargets_other:
      '{{count}} 個邊界層目標面（{{labels}}）表面積低於 {{threshold}} mm²。這些面過小無法乾淨網格化 — 網格器多半會捨棄它們, 並撕裂鄰近邊界層。',
    maxInternalSkewLow:
      '最大內部面歪度設在 3 以下時, 常會在擠出後拒絕有效的邊界層單元。建議調回 4（預設）。',
    refineMaxHighOnDenseCad:
      '在具有 {{surfaces}} 個表面的稠密 CAD 上, 細化層級上限 ≥ 5 會產生多面低品質單元。請將最大細化層級降至 4。',
    cellsBetweenLevelsHighDeepRefine:
      '寬過渡帶（層間單元數 ≥ 3）與深度細化（上限 ≥ 5）疊加會產生更多低品質單元。請只調高其中一項。',
    tightFeatureManySnapIters:
      '較緊的特徵角（≤ 60°）搭配大量 snap 迭代（≥ 15）會過度將頂點拉向邊 — 鏡射面上的邊界層可能因此不對稱。',
    minMedialAxisAngleHigh:
      '最小中軸夾角設在 90° 以上時, 中等曲率壁面（且目標面眾多）上的邊界層可能被拒絕。建議調降至 30°。',
    tetFailsOnDenseCad:
      '四面體網格在稠密 CAD（> 100 個表面）+ 逐面邊界層的情境下常失敗並靜默退回六面體。建議一開始就選六面體。',
    blHostileOverridesCombo:
      '同時設定了 {{count}} 個對邊界層不利的覆寫 — 出現低品質單元與邊界層失敗的風險很高。請將「引擎覆寫」重設為「標準」, 然後逐一微調。',
    sizeRatioHigh:
      '最大尺寸為最小尺寸的 {{ratio}} 倍 — 這是網格器可能難以處理的陡峭尺寸跳躍。請縮小差距, 或預期較長的網格化時間。',
    sizeRatioLow: '最大尺寸接近最小尺寸 — 細化幾乎不起作用。可以考慮擴大範圍。',
    blIgnoredNonCfd: '邊界層適用於 CFD 和 Wrap CHT，此任務不會包含邊界層。',
    // 「Refinement will auto-derive from Min Size / Max Size — leave
    // overrides on Auto unless you have a specific target.」— 稱這句
    // 為使用者最常看到的一條 info 訊息.
    refinementAutoDerives:
      '細化參數會依「最小尺寸/最大尺寸」自動推導 — 除非你有特定目標, 否則請將覆寫留在 Auto。',
    allMeshSizesManual:
      '所有網格尺寸覆寫皆手動設定 — 這會略過依「最小尺寸」的自動推導。',
  },
  meshSettings: {
    wrapChtLayerDescription:
      '「自動」遵循伺服器預設值，可能不生成邊界層。若要在所有流體與實體的接觸面上設定邊界層，請選擇「自訂」。',
    partCheckRefused: '無法保持此零件獨立。',
    partCheckOneBlock: '無法將所有零件保持分離。網格將使用單一實體。',
    partCheckOutside:
      '外部冷卻會將這些零件作為單一實體求解。目前尚不支援外部冷卻的獨立零件。',
    partCheckUnavailable: '尚未確認此上傳檔案的零件是否可分離。',
    partCheckCount: '找到的零件數：{{count}}',
    partCheckNever:
      '此上傳檔案從未檢查過獨立零件。若要為零件命名，請重新上傳 CAD；未命名時，零件會稱為 part_0、part_1 等。',
    layersSupportedModes: '僅限 CFD 或 Wrap CHT',
    blCustom: '自訂',
    blAutomatic: '自動',
    feaCoupling: '組立介面',
    feaShared: '共用節點 — 接合',
    feaIndependent: '獨立本體 — 可設定接觸',
    feaCouplingHint:
      '共用節點強制連續性。獨立本體需在 SimOps 中明確設定連接。變更此選項需要重新網格化，不會自動指定接觸。',

    // 「網格設定」— UI 標題. 一般設定 / 邊界 / 邊界層 / 進階等步驟的容器.
    title: '網格設定',
    simulation: '模擬',
    prepProvenanceRepair: '前處理：修復 · 匯入時設定',
    prepProvenanceWrap: '前處理：包覆 · 匯入時設定',
    comingSoon: '即將推出',
    chtNeedsSolidCad:
      'CHT 需要具有獨立實體區域的實體 CAD 檔案（STEP/BREP）。不支援 STL — 請以 STEP 重新上傳以執行 CHT。',
    wrapChtScope:
      '冷卻方式：{{cooling}}（在一般設定中選擇）。Wrap 會自動設定每個零件的角色。',
    chtCooling: '冷卻方式',
    chtCoolingOutside: '外部冷卻',
    chtCoolingInternal: '內部流道',
    chtCoolingOutsideTooltip:
      '零件由周圍的流體冷卻 — 例如空氣中的散熱片，或有氣流通過的機殼。零件會成為一個實體，其周圍封閉區域內的空間全部成為流體。',
    chtCoolingInternalTooltip:
      '冷卻液流經零件內部的通道 — 例如冷卻板或液冷模組。系統會找出該通道並將其網格化為流體，周圍的金屬則成為實體。找出開口並切出通道的步驟在邊界指定中進行。',
    passage: '最窄通道',
    stepNeedsCavity: '請先切割流體空腔再繼續，後續步驟以切割後的面為對象。',
    stepNeedsCoolantCarve:
      '請先切出冷卻液再繼續，邊界層與產生網格會等待切出完成。',
    applySuggestedSize: '使用建議尺寸',
    passagePlaceholder: 'mm',
    chtPassageHint:
      '冷卻液流經的最窄間隙（公釐）。請量測最小的孔或槽，而非主通道 — 比此值更細的部分可能被封閉並從流動中移除。',
    flowPassageHint:
      '流體流經的最窄間隙（公釐）。請量測最小的孔或槽，而非主通道 — 比此值更細的部分可能被封閉並從流動中移除。數值越小，抽取越精細，耗時也越長。',
    flowCavityTitle: '流體腔體',
    flowCavityDetect: '偵測',
    flowCavityDetecting: '檢查中',
    flowCavityDetectInFlight: '正在尋找此零件的開口，約需 15 秒。',
    flowCavityNeedsDetect:
      '請先檢查零件的開口 — 約需 15 秒，並會自動填入下方的最窄通道寬度。',
    flowCavityCost: '此尺寸約需 {{cells}}M 單元、{{gb}} GB、{{minutes}} 分鐘。',
    flowCavityPassageFrom_one:
      '最窄通道 {{value}} 公釐（由 {{count}} 個開口量得）。',
    flowCavityPassageFrom_other:
      '最窄通道 {{value}} 公釐（由 {{count}} 個開口量得）。',
    flowCavityPassageClamped:
      '量得 {{detected}} 公釐，但所需單元數超過上限，因此改填 {{suggested}} 公釐。',
    flowCavityTooFine:
      '對此零件而言太細 — 抽取網格會超過上限。請改用 {{min}} 公釐以上。',
    flowCavityCoarserThanDetected:
      '比量得的 {{detected}} 公釐更粗；比 {{set}} 公釐更細的通道可能會被封閉。',
    flowCavityExtract: '抽取',
    flowCavityReExtract: '重新抽取',
    flowCavityExtracting: '抽取中',
    flowCavityInFlight:
      '正在從此零件切出流體腔體。這需要幾分鐘 — 你可以離開此頁面，稍後再回來。',
    flowCavityNeedsPassage:
      '請先在上方設定最窄通道寬度 — 沒有這個值就無法判斷要保留哪些開口。',
    flowCavityNameBlank:
      '有一個面尚未命名。請在上方的牆面名稱中填寫，或刪除該列。',
    flowCavityNameRefused:
      '網格器無法使用名稱「{{name}}」。請在上方的牆面名稱或下方的表面清單中重新命名該面。',
    flowCavityUnknown: '無法確認是否已有流體腔體，請重新載入頁面後再試。',
    flowCavityChecking: '正在檢查是否有流體腔體…',
    flowCavityReady: '流體腔體已就緒，網格將以它為基礎生成。',
    flowCavityStale: '流體腔體已與目前設定不符，請重新抽取。',
    flowCavityAbsent:
      '尚無流體腔體。請在生成網格前先抽取 — 否則網格會覆蓋零件的外側。',
    flowCavityFailed: '無法開始抽取。請確認通道寬度後再試一次。',
    flowCavityDetectFailed: '無法檢查零件的開口。請重新載入頁面後再試一次。',
    flowCavityRunFailed: '上次抽取沒有完成。原因如下：',
    flowCavityTryAgain: '再試一次',
    wrapBlockedInternal:
      '此零件以 Wrap 前處理匯入，無法網格化此流動類型。請以 Repair 前處理重新匯入檔案以使用。',
    wrapBlockedFea:
      '此零件以 Wrap 前處理匯入，已合併為單一封閉表面 — FEA 需要原始 CAD 面來設定邊界條件。請以 Repair 前處理重新匯入檔案以執行 FEA。',
    cantMeshSim: '無法網格化 {{type}}：{{reason}}。',
    canStillMeshSim:
      '{{reason}}。你仍可網格化 {{type}}，但可能產生品質下降的單元。',
    flowType: '流動類型',
    internalNeedsCavity: '{{reason}}。你也可以切換為外流。',
    chtInternalTooltip:
      '冷卻液在零件內部流動。請在下方擷取，然後標記為流體實體。',
    chtExternalNotYet: '此前處理方式尚不支援以周圍空氣冷卻。',
    cantMeshExternal: '無法網格化外流：{{reason}}。',
    canStillMeshExternal:
      '{{reason}}。你仍可網格化外流，但風洞切割可能不乾淨，結果會品質下降。',
    external: '外流',
    internal: '內流',
    element: '單元類型',
    geometryPrep: '幾何前處理',
    geoPrepRepairTooltip:
      '在網格化前診斷並修復 CAD — 修正間隙、非流形邊與不良面。此為預設。',
    geoPrepWrapTooltip:
      '以乾淨的水密表面包覆零件，然後改為網格化該表面 — 對髒或漏的 CAD 更穩健。最適合用來檢查零件是否能網格化；逐面邊界標籤目前尚未帶過。',
    repair: '修復',
    wrap: '包覆',
    preset: '預設',
    // 尺寸預設 (Coarse/Medium/Fine) 的中文對應. 由於行內同時保留
    // 英文原名, 中文取「粗/中/細」單字即可, 不需重複 "網格" 二字.
    presetOptionCoarse: '粗',
    presetOptionMedium: '中',
    presetOptionFine: '細',
    // 更細的兩檔 — 為維持與英文原名的視覺對齊, 使用「更細」/「極細」.
    presetOptionVeryFine: '更細',
    presetOptionUltraFine: '極細',
    presetOptionCustom: '自訂',
    unitsDetectedTooltip:
      '幾何以 {{unit}} 建模（由 CAD 檔頭偵測）。後端會在求解時將網格重新縮放為 SI 公尺。',
    unitsPickTooltip:
      '請選擇幾何建模時所用的單位。後端會在求解時將網格重新縮放為 SI 公尺。STL/OBJ 檔沒有單位檔頭 — 必須選擇。',
    units: '單位',
    unitPlaceholder: '選擇…',
    maxSize: '最大尺寸',
    minSizePlaceholder: '≥1e-7',
    minSize: '最小尺寸',
    meshTooCoarseHex:
      ' Hex 網格會捕捉到錯誤的流動區域 — 請縮小最小尺寸或切換為 tet。',
    meshTooCoarseTet: ' Tet 網格在狹窄通道處可能當機或產生退化元素。',
    wrapMeshTooCoarse:
      '網格尺寸 {{minSize}} mm 會將 {{passage}} mm 的流道封死，只會得到部分流體的乾淨網格。請改為 {{target}} mm 或更小。',
    wrapChtMeshTooCoarse:
      '網格尺寸 {{minSize}} mm 可能會將 {{passage}} mm 的冷卻流道封死，網格便只包含部分冷卻液，且不會出現錯誤。請改為 {{target}} mm 或更小。',
    meshTooCoarse:
      '最小尺寸（{{minSize}} mm）超過最小通道半徑（{{radius}} mm）。{{advice}}',
    boundaryAssignment: '邊界指定',
    openingNames: {
      heading: '擷取前命名開口',
      intro_one:
        '在擷取前命名偵測到的開口，或標記為不是開口。留白會使用自動名稱。',
      intro_other:
        '在擷取前命名偵測到的 {{count}} 個開口，或標記出不是開口的項目。留白會使用自動名稱。',
      across: '直徑 {{mm}} mm',
      nameFor: '{{name}} 的名稱',
      unnamed: '開口 {{index}}',
      locate: '開口 {{name}} — 聚焦或停留即可在檢視器中顯示',
      detectFirst: '請先偵測開口。',
      empty: '這個零件未偵測到任何開口。',
      ambiguous: '部分開口具有相同的幾何識別資訊，無法安全命名。',
      unmatchedSummary_one:
        '有 1 個已儲存的名稱或標記與這個零件不符。請在擷取前清除。',
      unmatchedSummary_other:
        '有 {{count}} 個已儲存的名稱或標記與這個零件不符。請在擷取前清除。',
      clearAll: '全部清除',
      ignore: '將 {{name}} 標記為不是開口',
      restore: '重新將 {{name}} 視為開口',
      ignoredPlaceholder: '不是開口',
      cappedCount_one: '擷取前將封閉 1 個開口。',
      cappedCount_other: '擷取前將封閉 {{count}} 個開口。',
      allIgnored: '所有開口都已忽略，沒有可切割的開口。請至少還原一個。',
      carve: '使用這些名稱擷取流體區域',
    },
    wallNames: {
      heading: '為壁面命名',
      intro:
        '在檢視器中選取面，即可為流道壁的一部分命名，例如熱側或冷側。未命名的面會合併為同一個壁面。',
      empty:
        '尚未選取任何面。在檢視器中 Ctrl+點擊某個面，即可為該部分壁面命名。',
      face: 'F{{index}}',
      wasAnOpening: '原本偵測為開口。可以命名，或保持為壁面',
      nameFor: 'CAD 面 {{face}} 的名稱',
      remove: '取消命名 {{name}}',
      refusal: {
        blank: '請為此面命名，或將其移除。',
        noValidCharacters: '請使用英文字母、數字或底線，此名稱皆未包含。',
        reserved: '網格器會自行使用這個名稱，請另選一個。',
        interfaceInfix: '「_to_」保留給區域之間的介面使用。',
        autoAssigned: '以「opening_」開頭的名稱由系統自動指派。',
        collidesWithOpening:
          '開口已使用這個名稱，壁面與開口不能共用同一個名稱。',
        duplicateName: '兩個面會變成同一個 patch。空格與底線會被視為相同字元。',
      },
    },
    namedSurfaces: '具名表面',
    structuralBodies: '本體指派',
    bodyClassification: '本體分類',
    bodyClassificationParts_one: '{{count}} 個零件',
    bodyClassificationParts_other: '{{count}} 個零件',
    boundaryLayers: '邊界層',
    blOn: '開 · {{count}} 層',
    blOff: '關',
    advanced: '進階',
    order: '階數',
    orderTet: 'Linear (Tet4)',
    orderTetQuadratic: 'Quadratic (Tet10)',
    orderHex: 'Linear (Hex8)',
    orderPoly: 'Linear (Poly)',
    elementTetTooltip:
      'Tet（Tetrahedral/四面體）：4 節點的錐體元素。對髒 CAD 較穩健；由 gmsh 產生網格。',
    elementHexTooltip:
      'Hex（Hexahedral/六面體）：8 節點的方塊元素。每個單元的精度較高；由 snappyHexMesh 產生網格。',
    elementPolyTooltip:
      'Poly（Polyhedral/多面體）：任意面數的單元。以較少單元數穩健產生內流網格；由 cfMesh pMesh 產生網格。',
    // 「策略」在中文讀來偏商業/軍事語意; 此處是 OpenFOAM 挑選的
    // Tet / Hex 網格生成方法, 用「網格化方式」語境更明確.
    strategy: '網格化方式',
    auto: 'Auto',
    // 「逾時」易被讀為「已經超時」的完成態; 此處是控制上限的參數,
    // 因此改用「執行時間上限」清楚表達其為限制值.
    strategyTimeout: '網格化執行時間上限（秒）',
    strategyTimeoutHint:
      '每種網格化方式（Tet / Hex 等）在放棄前可執行的最長時間。留空則採用預設值。',
    generalSettings: '一般設定',
    stepContinue: '繼續至{{title}}',
    stepFinish: '完成設定',
    stepDone: '完成',
    stepsProgress: '{{done}}/{{total}} 個步驟',
    stepLockedHint: '請先完成步驟 {{n}}:{{title}}。',
    stepCtaBlockedHint: '請完成步驟 {{n}}:{{title}}。',
    cfdOnly: '僅限 CFD',
    notAvailable: '此處不適用',
  },
  partialMesh: {
    meshingDidNotFinish: '網格化未完成。',
    usableStillWritten:
      '仍寫入了可用的網格 — 你可以執行它，但結果可能不如乾淨網格可靠。',
  },
  meshFailure: {
    subcellOpening: {
      title: '有一個開口比一個網格單元還小。',
      hint: '請在其附近細分網格以便解析為開口，或接受它被網格化為牆面。',
    },
    openingDidNotSurvive: {
      title: '標記的開口未通過網格化。',
      hint: '網格器已將其面併入周圍的表面，導致該 patch 遺失。請開啟「貼合至 CAD 特徵邊」（Engine Overrides → Snap Fidelity）以保留開口的邊，或在其附近細分網格，再重新執行。',
    },
    fluidDomainDisconnected: {
      title: '流體區域未完全連通。',
      hint: '切換為流體萃取，或修復本體以密封流動路徑。',
    },
    cellCapExceeded: {
      title: '網格在完成前已達單元上限。',
      hint: '增加元素尺寸或縮小範圍以降低單元數。',
    },
    snapFailed: {
      title: '網格無法貼合 CAD 表面。',
      hint: '請修復 CAD，或放寬貼合設定後重新執行。',
    },
    layerFailed: {
      title: '部分牆面無法生成邊界層。',
      hint: '降低層數或首層高度，或開啟「優先 BL 覆蓋率」後重新執行。',
    },
    domainCoverageLost: {
      title: '流體區域的大部分在網格化過程中被捨棄。',
      hint: '網格器從內部種子點只能到達腔體的一部分 — 通常是表面缺陷（自相交或重合面）將腔體分割，而非單元尺寸的問題。請重新執行幾何診斷，若腔體報告缺陷請先修復；只有在流道確實狹窄時，縮小最小單元尺寸才有幫助。',
    },
    chtPartLabelsMismatch: {
      title: '零件名稱不再指向其零件。',
      hint: '請確認每個名稱都位於正確的零件上。若都正確，請重新上傳 CAD 以重新檢查零件，然後命名並重新網格化。不命名而直接網格化時，名稱會維持 part_0、part_1 等。',
    },
  },
  qualityWarningCodes: {
    // 「反轉單元」— 網格單元的 Jacobian 為負, 表示節點順序或 snap 變形
    // 造成幾何翻轉, 是 CFD 求解發散的主要來源.
    invertedCells: '存在反轉單元',
    highNonOrtho: '非正交性偏高',
    highSkewness: '偏斜度偏高',
    extremeAspect: '極端長寬比單元',
    snapTornWalls: '偵測到 snap 撕裂壁面',
    degenerateCells: '存在體積近乎為零的網格（可能來自細長薄片實體）',
  },
  meshResults: {
    qualityWarnings: '品質警告',
    wedgeCellsTitle:
      '來自 snappyHexMesh addLayers 的稜柱（楔形）單元 — 邊界層稜柱。',
    pyramidCellsTitle: '細化層級之間的過渡單元。通常佔總數 <1 %。',
    bulkCellsTitle:
      '體積主體單元 = 總數 − 楔形。可能包含少量的金字塔過渡單元（通常 <1 %）。在檢視器中載入網格可看到精確的各類型明細。',
    wedgeCellsFallbackTitle:
      'snappyHexMesh addLayers 產生的稜柱單元。為零表示 BL 擠出失敗。',
    elements: '網格單元',
    hexCells: 'Hex 單元',
    tetCells: 'Tet 單元',
    wedgeCells: '楔形單元',
    pyramidCells: '金字塔單元',
    polyCells: '多面體單元',
    polyCellsTitle:
      '任意多面體（cfMesh pMesh 單元，或 snappyHexMesh 分割六面體），以真實形狀原生算繪。',
    copiedToast: '已複製網格參數',
    storageWriteFailed: '儲存寫入失敗',
    noCopiedToast: '沒有已複製的網格參數 — 請先在某個網格上點選「複製」',
    corruptToast: '已儲存的網格參數已損毀',
    notMeshParamsToast: '已儲存的值不是網格參數',
    appliedToast: '已套用網格參數',
    strategy: '策略',
    element: '單元類型',
    maxSize: '最大尺寸',
    minSize: '最小尺寸',
    order: '階數',
    boundaryLayers: '邊界層',
    boundaryLayersValue: '{{value}} 層',
    copy: '複製',
    copyTooltip: '將此網格的參數儲存到瀏覽器儲存空間，以便套用至其他網格。',
    apply: '套用',
    applyTooltip: '將最近複製的網格參數套用至 Mesh Settings。',
    cancelled: '已取消',
    failedAt: '在 {{stage}} 失敗',
    failed: '失敗',
    stageSuffix: '停在 {{stage}}',
    lastLogLabel: '最後一條紀錄：',
    meshGenerated: '已產生網格',
    queuedFor: '排隊中 {{time}}',
    bypassActive: '略過啟用：已跳過輸入門檻{{detail}}。',
    bypassRecovery: '網格在適用處透過自動復原產生。',
    dirtyCadHintTitle: '此門檻可略過。',
    needsWrapTitle: '此零件需要包覆前處理。',
    needsWrapBody:
      '外殼切割無法直接處理此幾何。請以包覆前處理重新匯入，將其封閉為單一水密表面。',
    reimportWithWrap: '以包覆重新匯入',
    dirtyCadHintBody:
      '開啟「進階覆寫 → 略過髒 CAD 前置檢查門檻」以嘗試網格化；或以網格檔（STL / OBJ）重新上傳，並選擇 Wrap（包覆）匯入選項，即可重建乾淨的 CAD。',
    wireballRecovered: '網格已透過 alpha-wrap 外殼從線團自動復原。',
    namedSurfacesLost: '具名表面已遺失。',
    namedSurfacesLostBody:
      'PyTetwild（最後手段的備援）會將所有本體融合成單一 tet 網格，且無法保留面標籤。請以 HXT 或 Delaunay 重新網格化以取得具名表面。',
    inputSettings: '輸入設定',
    errorDetails: '錯誤詳情',
    pipelineStages: '流程階段',
    qualitySummary: '品質摘要',
    na: 'N/A',
    snapFidelity: 'Snap 保真度',
    boundaryLayerCoverage: '邊界層覆蓋率',
    metricMin: '最小',
    metricMax: '最大',
    metricAvg: '平均',
    metricStd: '標準差',
    metricCount: '數量',
    metricTarget: '目標',
    nonOrthogonality: '非正交性',
    max: '最大',
    avg: '平均',
    volume: '體積',
    stageRecovery: '復原',
    stageGeometryPrep: '幾何前處理',
    stageInputCheck: '輸入檢查',
    stageBoundaryCheck: '邊界檢查',
    stageMeshing: '網格化',
    stageQuality: '品質',
    stageHealing: '修復',
    stageConversion: '轉換',
    stageOpenfoamConversion: '格式轉換',
    stagePolymeshAudit: '網格稽核',
    stageLaplacianSmooth: '平滑化',
    stageQualityRetrigger: '品質重新觸發',
    stageQualityOptimization: '品質最佳化',
    stageCavityExtract: '腔體擷取',
    stageChtConvert: 'CHT 轉換',
    stageSplitRegions: '分割區域',
    stageCfmesh: '六面體網格器',
    stagePolyMesh: '多面體網格器',
    substageCaseBuild: '設定',
    substageBlockmesh: '背景網格',
    substageFeatureExtract: '邊緣偵測',
    substageDecompose: '平行分割',
    substageSnap: '表面貼合',
    substageReconstruct: '合併結果',
    substageSnapEdgeRecovery: '邊緣復原',
    substageAddLayers: '邊界層',
    substageCheckMesh: '品質檢查',
    badgeFluid: '流體',
    badgeSolid: '固體',
    badgeBl: 'BL',
    logs: '記錄',
    logsPreparing: '準備中…',
    logsDownloadFailed: '記錄下載失敗',
    partialMeshTitle: '部分網格',
    partialMeshBody:
      '在寫入此網格後網格生成即停止 — 請在檢視器中預覽以檢查已產生的內容。可能不完整。',
    partialMeshCells: '單元',
    partialMeshCellsTyped: '{{type}} 單元',
    partialMeshFluidDomain: '流體域',
    partialMeshConnected: '已連通',
    partialMeshDisconnected: '未連通',
  },
  readinessReason: {
    feaPinchPoint: '零件在單一點上與自身接觸（夾點）',
    feaNotWatertight: '表面有間隙/開放邊（並非封閉固體）',
    selfIntersection: '表面彼此交錯穿過',
    feaTopologyDefect: '拓撲缺陷',
    externalNonManifold: '本體共用內壁/面',
    externalOverlap: '兩個以上的本體重疊',
    externalPinchPoint: '零件收窄至一點',
    externalSurfaceDefect: '表面缺陷',
    internalNoCavity: '無法擷取出密閉的內部空腔',
    internalCavityNotExtracted:
      '尚未擷取流體空腔 — 請在 MeshGen → Mesh Settings 執行 Extract',
    internalCavityDegraded:
      '已擷取流體空腔，但鄰近的幾何缺陷可能使其周圍的網格品質下降',
    internalNoOpenings:
      '未偵測到流動開口，因此沒有可據以擷取空腔的對象 — 請封住進出口或檢查幾何',
    chtNotConformal: '並非共形多區域組件（需要兩個以上共用匹配介面的本體）',
    chtRegionNotClosed: '區域並非封閉固體',
    chtDegenerateFaces: '退化（零面積）面',
    chtRegionDefect: '區域缺陷',
  },
  wrapSuggest: {
    title: '此零件很可能無法網格化',
    description:
      'Diagnosis 發現{{blockers}}。這些會破壞外流網格化所依賴的域切割，因此一般網格化將會失敗 — 通常在數分鐘後才會出現。',
    body: '<b>Wrap</b> 前處理會將零件封閉成一個乾淨、水密的表面，能可靠地網格化。由於前處理是在匯入時設定，切換需重新匯入檔案 — Wrap 選項已為你備妥。',
    continueAnyway: '仍要繼續',
    reimport: '以 Wrap 重新匯入',
    noSolid: '無實體體積（僅表面）',
    pinch_one: '{{count}} 個夾點',
    pinch_other: '{{count}} 個夾點',
    overlap_one: '{{count}} 個相互貫穿的本體',
    overlap_other: '{{count}} 個相互貫穿的本體',
    openSurfaces: '開放表面（縫隙）',
    topologyDefects: '拓撲缺陷',
  },
  autoRetry: {
    label: '讓 AI 修正並重跑失敗的網格',
    hint: '網格失敗，或做出來未達品質標準時，AI 會讀出哪裡出了問題、改掉設定，再跑一次。',
    maxAttempts: '每個網格的重試次數',
  },
  retry: {
    historyTitle: '重試歷程',
    historyLoadFailed: '無法載入重試歷程。',
    historyRetry: '重新載入',
    attempt: '第 {{n}} 次嘗試',
    originalRun: '原始執行',
    aiBadge: 'AI · 自動',
    humanBadge: 'AI · 手動',
    platformBadge: '平台重新派送',
    convergedBadge: '已收斂',
    diagnosisHeading: '診斷',
    changesHeading: '變更內容',
    humanEdited: '（套用前已編輯）',
    whatWasTried: '目前已執行 {{runs}} 次 · 自動重試上限 {{max}} 次',
    lowConfidenceTitle: 'AI 建議重試（信心度低）',
    escalatedTitle: '需要您的審閱',
    declinedTitle: 'AI 不建議重試',
    applyAndRetry: '套用並重試',
    acceptBelowPolicy: '接受未達政策的結果',
    flagForReview: '標記待審閱',
    dismiss: '關閉',
    dismissed: '已駁回',
    notePlaceholder: '選填備註…',
    chatAction: '詢問顧問',
    chatTooltip: '就這個網格詢問重試顧問',
    chatPrompt:
      '網格 {{meshId}} 沒有產生可用的網格。請讀取該網格的幾何、參數、品質指標與日誌，告訴我它為何如此以及你會如何調整。',
    chatSessionTitle: '網格重試建議 — {{meshId}}',
    retryWithAi: '使用 AI 重試',
    retryWithAiTooltip:
      '代理會檢視失敗原因、調整網格設定，並以新的嘗試重新執行。',
    retryQueuedToast: '已送出重試 — 代理已將新的網格嘗試加入佇列。',
    retryFailedToast: '重試失敗：{{message}}',
    appliedToast: '已套用建議 — 新的網格嘗試已加入佇列。',
    dismissedToast: '已駁回建議。',
    qualityDelta: '品質 前 → 後',
    policyPass: '符合政策',
    policyFail: '未達政策',
    sopVersion: '重試 SOP 版本 {{v}}',
    copy: '複製',
    copied: '已複製',
    copyTooltip: '將完整重試記錄以純文字複製 — 可直接貼到聊天或訊息中。',
    logHeader: '重試記錄 · 網格 {{id}}',
    markNeedsYou: '需要你確認',
    markNeedsYouHint: 'AI 已備好修正方案，執行前想請你先看一下。',
    markRetrying: 'AI 重試中',
    markRetryingHint: 'AI 正在執行第 {{n}} 次嘗試。',
    markFixed: 'AI 已修正',
    markFixedHint: '第一次嘗試沒有成功，AI 在第 {{n}} 次修正了它。',
    markStopped: 'AI 已停止',
    markStoppedHint_one: 'AI 又試了一次，仍無法修正。',
    markStoppedHint_other: 'AI 試了 {{count}} 次，仍無法修正。',
    rollupFixed_one: '已修正 {{count}} 個',
    rollupFixed_other: '已修正 {{count}} 個',
    rollupNeedsYou_one: '{{count}} 個需要你確認',
    rollupNeedsYou_other: '{{count}} 個需要你確認',
    headerNeedsYou_one: '{{count}} 個網格需要你確認',
    headerNeedsYou_other: '{{count}} 個網格需要你確認',
    attemptSwitcherLabel: '嘗試',
    attemptOutcomeFailed: '失敗',
    attemptOutcomeBelowBar: '未達標準',
    attemptOutcomeRunning: '執行中',
    attemptOutcomeGood: '良好',
    attemptMadeByAi: '這次嘗試由 AI 產生',
    attemptMadeByYou: '你的原始嘗試',
    attemptChanged: 'AI 變更了什麼',
  },
  feaJoins: {
    couplingLabel: 'FEA 中實體配對的連接方式',
    coupling:
      'FEA 模型以下列三種方式之一連接一對實體：\n\n黏結：兩個實體共用一個面及其節點。接合處傳遞拉力、剪力與壓力，且永遠不會張開。在 MeshGen 選擇「共用節點 — 接合」建立網格即可得到。\n\n束縛（tie）：兩個各自建立網格的面被黏合，即使節點沒有對齊也會一起移動。與黏結相同，它傳遞拉力且不會張開。SimOps 可在「束縛介面」為熱傳導新增束縛；結構分析則透過 API 設定。\n\n接觸：兩個面互相推擠但可以分離，除非設定摩擦，否則會滑動。它不傳遞拉力，且會使求解成為非線性。在 SimOps 的「接觸」中新增。\n\n束縛與接觸需要網格未合併的面：共用節點網格中的間隙，或以「獨立本體」建立網格的配對。',
    bonded: '黏結',
    bondedCaption: '單一面，共用節點。',
    tie: '束縛',
    tieCaption: '兩個網格，互相黏合。',
    contact: '接觸',
    contactCaption: '互相推擠，可分離或滑動。',
    couplingThermalLabel: '熱傳導中實體配對的連接方式',
    couplingThermal:
      '熱傳導模型以下列兩種方式之一連接一對實體：\n\n黏結：兩個實體共用一個面及其節點，熱可自由通過該面。在 MeshGen 選擇「共用節點 — 接合」建立網格即可得到。\n\n束縛（tie）：兩個各自建立網格的面被黏合，即使節點沒有對齊也維持相同溫度。在此處的「束縛介面」新增束縛；先選的面為從屬側。\n\n沒有黏結或束縛、僅相接的面不會傳熱。束縛需要網格未合併的面：共用節點網格中的間隙，或以「獨立本體」建立網格的配對。',
  },
} as const;
